import styled from "styled-components";

export const Content = styled.div`
    background: white;
    padding-bottom: 20px;
    position: relative;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        margin: 0 30px 30px;
    }

    ${({ theme }) => theme.breakpoints.xl.mediaquery} {
        margin: 0 0 0 30px;
    }
`;

export const LoadingSpinnerWrapper = styled.div`
    position: relative;
    padding-top: 10px;
    padding-left: 10px;
`;
